import { Component, OnInit, OnDestroy, AfterViewInit, Input, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { ConfigService } from '../../../../services/config.service';
import { DataIoService } from '../../../../services/data-io.service';
import { LoadinganimationComponent } from '../loadinganimation/loadinganimation.component';
import { MenuNode } from '../../../../classes';
import { EnabledNodesPipe } from '../../../../pipes/enabled-nodes.pipe';
import { TextdisplayComponent } from '../../../helpers/textdisplay/textdisplay.component';
import { DeviceDetectorService } from 'ngx-device-detector';
@Component({
    selector: 'screen-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild("wrapElement", { read: ElementRef }) wrapElement: ElementRef;
    _debug: boolean = true;
    __debug = (msg) => { };
    debug = console.debug
    _initTop: number = 43.61666667;
    _top: number = 43.61666667;
    //_elementHeight :number = 12.8;
    //_elementHeight :number = 11;
    _elementHeight: number = 10.64;
    opacity_begin: number;
    opacity_end: number;
    top: string;
    titleopacity: number = 1;
    mode: string;
    menuIcon: string;
    eventSubscription: any;
    menuElements: Array<MenuNode>;
    currentElement: MenuNode;
    title: string;
    subtitle: string;
    template_parameters: Array<string>;
    darkTitle: boolean = false;
    getColor(element: MenuNode) {
        if (this.currentElement == element) {
            return 'white';
        } else {
            return '#7F7F7F';
        }
    }
    constructor(
        private menuService: MenuService,
        private ioService: DataIoService,
        private config: ConfigService,
        private enabledNodes: EnabledNodesPipe,
        private deviceService: DeviceDetectorService
    ) {
        this.debug("Running menu on browser: " + this.deviceService.browser);
    }
    setCurrent(node: MenuNode) {
        //this.debug("Current element:" +node.getTitle());
        this.currentElement = node;
        this.calculateTop();
        this.top = this._top + "%";
        this.applyOpacity();
    }


    setCurrentElement(element?: MenuNode) {
        if (element instanceof MenuNode) {
            if (this.currentElement != undefined && this.currentElement != element) {
                let oct = this.currentElement.onConfirmAction;
                if (oct !== null && oct !== undefined && oct != "") {
                    this.mayBlink = true;
                    this.debug("Enabling blinking.");
                }
            }
            this.currentElement = element;
            this.ioService.elementFocused(element);
            this.ioService.infoTextAvailable(element);

        }
        return;
    }

    hasParameter(param: string): boolean {
        return this._menuNode.hasParameter(param);
    }

    hasNextMenuItem(): boolean {

        // wir sind auf dem ober-element, dieses ist offen
        if (this.currentElement.isOpen()) {
            return ((this.currentElement.getChilds().length > 0) || this.currentElement.hasNextSibling());
        }
        if (this.menuNode.getLevel() + 2 == this.currentElement.getLevel()) {
            if (!this.currentElement.hasNextSibling()) {
                return this.currentElement.getParent().hasNextSibling();
            } else {
                return true;
            }
        }

        return this.currentElement.hasNextSibling();

    }
    getVisibleElementByIndex(idx: number): MenuNode {
        let count: number = 0;

        for (let element of this.menuElements) {
            if (count == idx) {
                return element;
            }
            count++;
            if (element.isOpen()) {
                for (let subElement of element.getChilds()) {
                    if (count == idx) {
                        return subElement;
                    }
                    count++;
                }
            }
        }
    }
    calculateElement(): number {
        return -1 * Math.round((this._top - this._initTop) / this._elementHeight);
    }
    maxTop(): number {
        return this._initTop - (this._elementHeight) * (this.countVisibleItems() - 1);
    }
    minTop() {
        return this._initTop;
    }

    calculateTop(): void {
        let factor = this.elementsAbove(this.currentElement);
        this._top = this._initTop - (this._elementHeight * factor);
        this.debug("Elements above: " + factor);
    }
    countVisibleItems() {
        let count = 0;
        for (let menuNode of this.menuElements) {
            count++;
            if (menuNode.isOpen()) {
                count += menuNode.getChilds().length;
            }
        }
        return count;
    }
    elementsAbove(element: MenuNode) {
        let count = 0;
        for (let menuNode of this.menuElements) {
            if (menuNode == element) {
                return count;
            }
            count++;
            if (menuNode.isOpen()) {

                for (let subMenuNode of menuNode.getChilds()) {
                    if (subMenuNode === element) {
                        return count;
                    }
                    count++;
                }
            }

        }
    }
    selectNextMenuItem() {
        if (!this.hasNextMenuItem()) {
            return;
        }

        // wir sind auf dem ober-element, dieses ist offen
        if (this.currentElement.isOpen()) {
            if (this.currentElement.getChilds().length > 0) {
                this.setCurrentElement(this.currentElement.getChildByIndex(0));
            } else {
                this.setCurrentElement(this.currentElement.getNextSibling());
            }
            return;
            //this.debug("Returning first child of " + this.submenuOpenOn.getName() + " which is " + this.currentElement.getName() );
        }
        // wir sind schon auf einem untermenüpunkt
        if (this.menuNode.getLevel() + 2 == this.currentElement.getLevel()) {
            if (this.currentElement.hasNextSibling()) {
                this.setCurrentElement(this.currentElement.getNextSibling());
                return;
            } else {
                if (this.currentElement.getParent().hasNextSibling()) {
                    this.setCurrentElement(this.currentElement.getParent().getNextSibling());
                    return;
                }
            }
        }

        this.setCurrentElement(this.currentElement.getNextSibling());
        return;
    }

    hasPreviousMenuItem() {
        return (this.currentElement != this.menuElements[0]);

    }

    selectPreviousMenuItem() {
        if (this.menuNode.getLevel() + 2 == this.currentElement.getLevel()) {
            if (this.currentElement.hasPreviousSibling()) {
                this.setCurrentElement(this.currentElement.getPreviousSibling());
                return;
            } else {
                this.setCurrentElement(this.currentElement.getParent());
                return;
            }
        }
        if (this.currentElement.getPreviousSibling().isOpen()) {
            let previousSibling = this.currentElement.getPreviousSibling();
            if (previousSibling.getChilds().length > 0) {
                this.setCurrentElement(previousSibling.getChildByIndex(previousSibling.getChilds().length - 1));
                return;
            } else {
                this.setCurrentElement(previousSibling);
                return;
            }
        } else {
            this.setCurrentElement(this.currentElement.getPreviousSibling());
            return;
        }
        //this.currentElement = this.menuElements[this.menuElements.indexOf(this.currentElement)-1];
    }

    panning: boolean = true;
    changed = false;
    mayBlink = false;
    blink() {
        if (!this.changed && this.mayBlink) {

            this.changed = true;
            this.menuService.blinkButton('confirm');
        }
    }
    eventHandler(event) {


        if (this.menuElements.length == 0) {
            switch (event) {
                case 'up':
                case 'down':
                case 'panup':
                case 'pandown':
                case 'panstart':
                case 'panend':

                case 'confirm': {
                    return;
                }
                default: { }
            }
        }
        switch (event) {
            case 'resized': {
                this.debug("Picked up resize event..");
                this.readjustSize();
                return;
            }
            case 'panup': {

                if (this.panning) {
                    //console.log("Panning up");
                    this.panUp();
                    this.blink();
                }

                return;
            }
            case 'pandown': {
                if (this.panning) {
                    //console.log("Panning down");
                    this.panDown();
                    this.blink();
                }
                return;
            }

            case 'down': {
                this.debug("down pressed.");
                if (this.hasNextMenuItem()) {
                    this.selectNextMenuItem();
                    this.blink();
                }
                //this.debug("Currently Selected: "+this.currentElement.getName()+ "that is " + (this.currentElement.isEnabled()?"enabled.":"disabled."));
                /*
                for(let el of this.currentElement.getChilds()){
                    this.debug("Child: ID:"+el.getIdentifier()+" "+el.getTitle());
                }*/

                break;
            }
            case 'up': {

                if (this.hasPreviousMenuItem()) {
                    this.selectPreviousMenuItem();
                    this.blink();
                }
                /*
                this.debug("Currently Selected: "+this.currentElement.getName());
                for(let el of this.currentElement.getChilds()){
                    this.debug("Child: "+el.getIdentifier());
                }
                */
                break;
            }
            case 'confirm': {
                this.debug("############## CONFIRM CALLED ON " + this.currentElement.getTitle());
                let confirmation = this.currentElement.onConfirm({ node: this.currentElement });

                if (this.mode == "setup" && !this.currentElement.hasTarget()) {
                    this.debug("got confirm in menu.component");
                    if (this.menuService.hasNextMenuItem()) {
                        this.menuService.selectNextMenuItem();
                    } else {
                        if (this.menuService.parentHasNext()) {
                            this.menuService.selectParentNext();
                        }
                    }
                    return;
                }

                if (this.currentElement.hasTarget()) {
                    this.debug("Confirm on " + this.currentElement.getTitle());
                    this.debug("Going to target: " + this.currentElement.getTarget());
                    let target = this.currentElement.getTargetNode();
                    if (target == null) {
                        this.debug("target was null. going back.");
                        this.menuService.historyBack(confirmation);
                        return;
                    }
                    this.debug("Going to target: " + target.getName());
                    this.debug("Marking " + this.currentElement.getIdentifier() + ' selected was:' + this.currentElement.selected);
                    if ([null, undefined, 'true', 'false'].includes(this.currentElement.selected)) {
                        this.debug("Marking " + this.currentElement.getTitle() + " as selected for later return");
                        this.currentElement.selected = "true";
                        this.currentElement.getSiblings().every((node: MenuNode) => {
                            if ([null, undefined, 'true', 'false'].includes(node.selected)) {
                                node.selected = 'false';
                            }
                        });
                    }

                    this.menuService.goto(target, confirmation);
                    return;
                } else {
                    this.debug("No target on " + this.currentElement.getTitle());
                }

                // open children as submenu if level is one
                if (this.menuNode.getLevel() + 1 == this.currentElement.getLevel()) {
                    this.debug("Visible sub-elements: " + this.currentElement.getChilds().length);
                    if (!this.currentElement.isOpen() /* && this.currentElement.childs.length > 0*/) {
                        this.debug("opening menu-entry:" + this.currentElement.getTitle());
                        this.currentElement.open();
                    } else {
                        this.debug("closing menu-entry:" + this.currentElement.getTitle());
                        this.currentElement.close();
                    }

                }
                // if element is submenu-element, open children in new menu.
                if (this.menuNode.getLevel() + 2 == this.currentElement.getLevel()) {
                    if (this.hasParameter('recurse') && this.currentElement.hasChild()) {
                        this.debug("Marking " + this.currentElement.getTitle() + " as selected for later return");

                        this.menuService.goto(this.currentElement.getChildByIndex(0));
                        this.currentElement.selected = "true";
                    }
                }

                //goto next sibling if in setup.


                break;
            }
            case 'question': {
                if (this.currentElement.hasHelp()) {
                    this.currentElement.selected = "true";
                    this.menuService.showHelp();
                }
                return;
            }
            case 'back': {
                this.debug("got back in menu.component.");
                if (this.menuNode.hasBackTarget()) {
                    let backTarget = this.menuService.goto(this.menuNode.getBackTargetNode());
                    return;
                }
                if (!this.menuService.hierarchyUp()) {
                    if (this.menuService.hasPreviousMenuItem()) {
                        this.menuService.selectPreviousMenuItem();
                    } else {
                        this.menuService.historyBack();
                    }
                }

                break;
            }
            case 'panstart': {
                console.log("panstart");
                this.panning = true;
                this.transition = false;
                return;
            }
            case 'panend': {
                console.log("panend");
                this.transition = true;
                this.panning = false;
                this.blink();
                break;
            }
        }
        this.calculateTop();
        this.top = this._top + "%";
        this.applyOpacity();
        //this.debug("top:"+this._top);
    }
    isNotPanning() {
        if (this.panning) {
            return false;
        } else {
            return true;
        }
    }
    transitionalMovement() {
        this.debug("Was asked for transitional, answering " + (this.transition ? "yes" : "no"));
        return this.transition;
    }
    set transition(value) {
        //console.log( (value?"enabling":"disabling")+" transitions");
        this._transition = value;
    }
    get transition() {
        return this._transition;
    }
    _transition: boolean = true;
    isPanning() {
        return this.panning;
    }
    applyPan() {
        this.top = this._top + "%";
        this.setCurrentElement(this.getVisibleElementByIndex(this.calculateElement()));
        this.applyOpacity();
    }

    panStep: number = 1.6;
    panUp() {
        if (this.maxTop() < this._top - this.panStep) {
            this._top -= this.panStep;
        }
        this.applyPan();
    }
    panDown() {
        if (this.minTop() > this._top + this.panStep) {
            this._top += this.panStep;
        }


        this.applyPan();
    }


    applyOpacity() {
        if ((this._top) <= (this.opacity_end)) {
            this.titleopacity = 0;
            return;
        }
        if ((this._top) >= (this.opacity_begin)) {
            this.titleopacity = 1;
            return;
        }

        this.titleopacity = 1.0 - (((this._top) - (this.opacity_begin)) / ((this.opacity_end) - (this.opacity_begin)));
        if (this.titleopacity < 0) {
            this.titleopacity = 0;
        }
    }


    _menuNode: MenuNode;
    get menuNode() {
        return this._menuNode;
    }
    set menuNode(value: MenuNode) {
        this._menuNode = value;
    }
    ngOnDestroy() {
        this.customDestroy();
    }
    ngOnInit() {
        if (this.currentElement) {
            this.debug("Not Destroyed before. currentElement: " + this.currentElement.getTitle());
        }
        this.menuNode = this.menuService.getCurrentNode();
        this.menuIcon = this.menuNode.getIcon();
        this.debug("ngOnInit");
        if (this.menuService.hasParameter('mainmenu')) {
            this.mode = 'mainmenu';
        }
        if (this.menuService.hasParameter('setup')) {
            this.mode = 'setup';
        }
        this.debug("ngOnInit");

        this.top = this._top + "%";
        this.opacity_begin = this._top - 0.5 * this._elementHeight;
        this.subtitle = this.menuNode.getSubTitle();
        this.opacity_end = this._top - (this.subtitle ? 2 : 3) * this._elementHeight;
        this.title = this.menuNode.getTitle();
        if (this.hasParameter('darktitle')) {
            this.darkTitle = true;
        }
        this.debug("Filtering elements:");
        this.menuNode.run((node) => node.setFilter(this.menuNode.getTitle(), this.enabledNodes.transform), 3);
        this.menuElements = this.menuNode.getChilds();
        this.setCurrentElement(this.menuNode.getChildByIndex(0));

        this.debug("Opening menu " + this.menuNode.getTitle() + " with elements:");
        let selected = null;

        for (let el of this.menuElements) {
            if (el.isSelected()) {
                this.debug("Found selected element: " + el.getTitle() + ": " + el.selected);
                selected = el;
                if (el.selected == 'true') {
                    el.selected = '';
                }
            }
            for (let subEl of el.getChilds()) {
                if (subEl.isSelected()) {
                    this.debug("Found selected element: " + subEl.getTitle() + ": " + subEl.selected);
                    selected = subEl;
                    if (subEl.selected == 'true') {
                        subEl.selected = '';
                    }
                }
            }
        }

        if (selected) {
            console.log("selected found");
            this.setCurrentElement(selected);
            this.calculateTop();
            this.top = this._top + "%";
            this.applyOpacity();
            this.debug("top:" + this._top);
        } else {
            console.log("selected not found");
        }
        this.mayBlink = false;
        this.debug("#### OnInit, subscribing.");
        this.eventSubscription = this.ioService.inputs.events$.subscribe(
            (event) => { this.eventHandler(event); }
        );

    }
    customDestroy() {
        //this.debug("#### OnDestroy, unsubscribing.");
        this.eventSubscription.unsubscribe();
        //this.debug("#### OnDestroy, unsubscribed.");
        this.eventSubscription = null;
        this.menuNode.run((node) => node.removeFilter(this.menuNode.getTitle()), 3);
    }

    _heightAdjusted = false;
    adjustHeight() {
        this.debug("Readjusting size.");
        if (this.deviceService.browser != "Chrome") {
            return;
        }
        // get one menu-item.

        let el = this.wrapElement.nativeElement.querySelector(' .menu-row > .menu-item-wrap > .menu-item');
        if (el === undefined || el === null) {
            el = this.wrapElement.nativeElement.querySelector('.submenu-row > .menu-item-wrap > .menu-item');
        }
        if (el) {
            this._heightAdjusted = true;
            let ww = this.ioService.getWindowWidth();

            //let mww = 483;
            let mww = 207;

            let percentage = (855 - ww) / (855 - mww);
            console.log("Percentage: " + percentage);
            this.debug("Percentage: " + percentage);
            //let factor = (0.995-0.055*percentage);
            //let factor = (0.995-0.045*percentage);

            //alert("ww"+ww);
            if (ww == 720) {
                percentage = 0.58;
            }
            if (ww >= 855) {
                percentage = 0.73;
            }
            let factor = parseFloat((1.04 - 0.16 * (1 - percentage)).toFixed(2));
            console.log("ww:" + ww);
            console.log("Factor: " + factor);
            let clientHeight = (this.wrapElement.nativeElement.clientHeight * factor);
            this.debug("Client Height: " + clientHeight);
            let offsetHeight = el.offsetHeight;
            this.debug("Offset Height: " + offsetHeight);
            this._elementHeight = clientHeight / offsetHeight;
            this.debug("Element Height: " + this._elementHeight);
            this.setCurrentElement(this.currentElement);
            this.calculateTop();
            this.top = this._top + "%";
            this.applyOpacity();
            this.debug("top:" + this._top);

        } else {
            this.debug("Cannot readjust size: got no item.");
        }

    }

    ngAfterViewInit() {
        this.readjustSize();
    }
    isOpen(node: MenuNode) {
        return node.isOpen();
    }
    readjustSize() {
        setTimeout(() => {
            this._heightAdjusted = false;
            this.adjustHeight();
        }, 250);
    }
}
